import React from "react";

const About = () => {
  return (
    <section className="section about-section">
      <h2 className="section-title">about us</h2>
      <p>
        In publishing and graphic design, Lorem ipsum is a placeholder text
        commonly used to demonstrate the visual form of a document or a typeface
        without relying on meaningful content. Lorem ipsum may be used as a
        placeholder before final copy is available.
      </p>
    </section>
  );
};

export default About;
